/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Short name of this size
 */
export enum Size {
  MEDIUM = 'medium',
  LARGE = 'large',
  XLARGE = 'xlarge',
}
